export default class ProductCardSearchUtil {
  static SORT_TYPE_ALPHABETICALLY = "alphabetically";
  static SORT_TYPE_MANUALLY = "manually";

  static isSortAlphabetically(sortType) {
    return !sortType || this.SORT_TYPE_ALPHABETICALLY === sortType;
  }

  static isSortManually(sortType) {
    return this.SORT_TYPE_MANUALLY === sortType;
  }

  static sortResultsByManualType(productCardsList, identifiers, idField = "isbn13") {
    productCardsList.sort((a, b) => {
      return identifiers.indexOf(a[idField]) - identifiers.indexOf(b[idField]);
    });
  }
}
